export default __webpack_public_path__ + "static/media/ico-graph-d.06306308.svg";